<script lang="ts">
    import { onDestroy, onMount } from "svelte";

    export let darken_menu: boolean = false;

    onMount(() => {
        document.body.classList.add("light");

        darken_menu && document.querySelector("header").classList.add("darken");
    });
    onDestroy(() => {
        document.body.classList.remove("light");
        darken_menu && document.querySelector("header").classList.remove("darken");
    });
</script>
